import { CryptoRandomFloat } from "../common/crypto-random-float";

export class Coordinates {
	public latitude: number;
	public longitude: number;

	public randomize(): Coordinates {
		this.latitude = Math.ceil(CryptoRandomFloat.getCryptoRandomFloat() * 90) * (Math.round(CryptoRandomFloat.getCryptoRandomFloat()) ? 1 : -1);
		this.longitude = Math.ceil(CryptoRandomFloat.getCryptoRandomFloat() * 180) * (Math.round(CryptoRandomFloat.getCryptoRandomFloat()) ? 1 : -1);

		return this;
	}

	public static distance(a: Coordinates, b: Coordinates): number {
		return Math.sqrt((a.latitude - b.latitude) * (a.latitude - b.latitude) + (a.longitude - b.longitude) * (a.longitude - b.longitude));
	}

	constructor(latitude: number = 0, longitude: number = 0) {
		this.latitude = latitude;
		this.longitude = longitude;
	}
}
